var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"scroll-bar",attrs:{"title":"我的文件","visible":_vm.dialogVisible,"width":"80%","top":"5vh","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"fileDiv"},[_c('myFile')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }